"use client";
import { jsx as l } from "react/jsx-runtime";
import { forwardRef as K } from "react";
import { Field as L } from "../Field/Field.js";
const Q = K(
  ({
    // `Field` props
    autoFocus: r,
    className: t,
    defaultValue: e,
    errorText: m,
    helperText: n,
    iconEnd: o,
    iconStart: b,
    id: f,
    isDisabled: u,
    isInvalid: c,
    isReadOnly: p,
    isRequired: x,
    labelText: d,
    name: h,
    placeholder: j,
    size: w,
    slotEnd: y,
    slotStart: F,
    value: I,
    // Control-specific props
    autoComplete: g,
    inputMode: k,
    maxLength: q,
    minLength: v,
    onBlur: z,
    onChange: A,
    onClick: B,
    onFocus: C,
    onKeyDown: D,
    onKeyUp: E,
    pattern: G,
    type: H,
    // Spread any additional props passed by the user (such as custom `data-*` attributes)
    ...a
  }, J) => /* @__PURE__ */ l(
    L,
    {
      autoFocus: r,
      className: t,
      defaultValue: e,
      errorText: m,
      helperText: n,
      iconEnd: o,
      iconStart: b,
      id: f,
      isDisabled: u,
      isInvalid: c,
      isReadOnly: p,
      isRequired: x,
      labelText: d,
      name: h,
      placeholder: j,
      size: w,
      slotEnd: y,
      slotStart: F,
      value: I,
      children: (i) => ("aria-label" in i && "aria-labelledby" in a && delete i["aria-label"], /* @__PURE__ */ l(
        "input",
        {
          ...i,
          autoComplete: g,
          inputMode: k,
          maxLength: q,
          minLength: v,
          onBlur: z,
          onClick: B,
          onFocus: C,
          onChange: A,
          onKeyDown: D,
          onKeyUp: E,
          pattern: G,
          ref: J,
          type: H,
          ...a
        }
      ))
    }
  )
);
export {
  Q as Input
};
